import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseState, ViewMode } from 'app/area/case/types-store';

export const expandAll = (caseState:CaseState, uiEngineProps:ConnectedComponentProps) => {
  const hostprops = uiEngineProps.hostProps();
  return {
    expandAll: (hostprops && hostprops.expandAll) || caseState.viewMode === ViewMode.scroll
  };
};
